import React, { useEffect, useRef, useState } from "react";
import { Input, Label } from "../styled";
import {
  Container,
  Customization,
  Hr,
  ImageContainer,
  PersonalizeWrapper,
  PreViewerContainer,
  Select,
} from "./styled";

interface ToTypeProps {
  errorSign: boolean;
  errorInitial: boolean;
  signature: string;
  initial: string;
  handleSignatureChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInitialChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ToType = ({
  errorSign,
  errorInitial,
  signature,
  initial,
  handleSignatureChange,
  handleInitialChange,
}: ToTypeProps) => {
  const [personalized, setPersonalized] = useState<boolean>(false);
  const [selectedFont, setSelectedFont] = useState("Barcelony");

  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLParagraphElement>(null);
  useEffect(() => {
    const adjustFontSize = () => {
      const container = containerRef.current;
      const text = textRef.current;

      if (container && text) {
        let fontSize = parseInt("30px");
        text.style.fontSize = `${fontSize}px`;

        while (text.scrollWidth > container.offsetWidth - 40 && fontSize > 10) {
          fontSize -= 1;
          text.style.fontSize = `${fontSize}px`;
        }

        while (
          text.scrollWidth < container.offsetWidth - 40 &&
          fontSize < parseInt("30px")
        ) {
          fontSize += 1;
          text.style.fontSize = `${fontSize}px`;
        }
      }
    };

    adjustFontSize();
    window.addEventListener("resize", adjustFontSize);

    return () => {
      window.removeEventListener("resize", adjustFontSize);
    };
  }, [signature, initial]);

  const handlePersonalized = () => {
    setPersonalized(!personalized);
  };

  const handleFontChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedFont(e.target.value);
  };

  const abbreviateSignature = (signature: string) => {
    const words = signature.split(" ");

    if (words.length > 1) {
      const firstWord = words[0];
      const remainingWords = words.slice(1);

      const longWordsIndices = remainingWords
        .map((word, index) => (word.length > 3 ? index : -1))
        .filter((index) => index !== -1);

      if (longWordsIndices.length > 2) {
        longWordsIndices.slice(0, -2).forEach((index) => {
          remainingWords[index] = remainingWords[index].charAt(0) + ".";
        });
      }
      return [firstWord, ...remainingWords].join(" ");
    }
    return signature;
  };

  const abbreviatedSignature = abbreviateSignature(signature);

  return (
    <Container>
      {personalized && (
        <>
          <PersonalizeWrapper>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                position: "relative",
              }}
            >
              <Label htmlFor="signature">Nome para assinatura:</Label>

              <Input
                type="text"
                id="signature"
                value={signature}
                onChange={handleSignatureChange}
              />
              {errorSign && (
                <p
                  style={{
                    position: "absolute",
                    bottom: "-14px",
                    left: "8px",
                    fontSize: "12px",
                    color: "red",
                  }}
                >
                  Por favor, digite sua assinatura
                </p>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                position: "relative",
              }}
            >
              <Label htmlFor="signature">Sigla para rubrica:</Label>
              <Input
                type="text"
                id="initial-input"
                value={initial}
                onChange={handleInitialChange}
                maxLength={3}
              />
              {errorInitial && (
                <p
                  style={{
                    position: "absolute",
                    bottom: "-14px",
                    left: "8px",
                    fontSize: "12px",
                    color: "red",
                  }}
                >
                  Por favor, digite sua rubrica
                </p>
              )}
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  position: "relative",
                }}
              >
                <Label htmlFor="font">Fonte:</Label>
                <Select
                  id="font"
                  onChange={handleFontChange}
                  value={selectedFont}
                  selectedFont={selectedFont}
                >
                  <option value="Caveat">Caveat</option>
                  <option value="Allura">Allura</option>
                  <option value="Barcelony">Barcelony</option>
                </Select>
              </div>
            </div>
            <Hr />
          </PersonalizeWrapper>
        </>
      )}
      <PreViewerContainer>
        <div>
          <p style={{ color: "#474747", fontSize: "12px" }}>
            Pré-visualização da assinatura
          </p>
          <ImageContainer ref={containerRef} selectedFont={selectedFont}>
            <p ref={textRef} id="preview-sign">
              {abbreviatedSignature}
            </p>
          </ImageContainer>
        </div>
        <div>
          <p style={{ color: "#474747", fontSize: "12px" }}>
            Pré-visualização da Rubrica
          </p>
          <ImageContainer selectedFont={selectedFont}>
            <p id="preview-initial" style={{ fontSize: "36px" }}>
              {initial}
            </p>
          </ImageContainer>
        </div>
      </PreViewerContainer>
      <Customization onClick={handlePersonalized}>
        <span style={{ fontSize: "22px" }}>{personalized ? "-" : "+"}</span>
        <p>Personalizar</p>
      </Customization>
    </Container>
  );
};

export default ToType;
